import DropdownMenu, {
    DropdownItem,
    DropdownItemGroup
} from '@atlaskit/dropdown-menu';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { disconnect } from '../connection';
import { EditProfile, IconUserSm } from '../icons';
import { updateSettings } from '../settings';
import {
    kickParticipant,
} from '../../base/participants';

const LogoutButton = ({isMod, avatarUrl, isConference, handleProfile, handleSecurity, handleLogout}) => {
    const _isModerator = isMod;

    return (
        <div className = { 'logout-button' }>
            <DropdownMenu
                className = { 'dropdown-menu-logout-btn' }
                triggerButtonProps = {{
                    component: () => (
                        <div
                            style = {{
                                width: 35
                            }}>
                            {_isModerator ? (avatarUrl ?
                                <div className='wrap-avatar-account'><img className="avatar-account"
                                          src={avatarUrl}/></div> : <IconUserSm
                                color = { 'white' } />) : <EditProfile color = { 'white' } />}
                        </div>
                    )
                }}
                position = { 'bottom right' }
                triggerType = 'button' >
                <DropdownItemGroup>
                    {!isConference && (
                        <>
                            <DropdownItem
                                onClick = { handleProfile}>Profile</DropdownItem>
                            <DropdownItem
                                onClick = { handleSecurity}>Security</DropdownItem>
                        </>
                    )}
                    <DropdownItem
                        onClick = {handleLogout}>Logout</DropdownItem>
                </DropdownItemGroup>
            </DropdownMenu>
        </div>

    );
};

export { LogoutButton };
